var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0H13.125L18.125 5V18.75C18.125 19.0815 17.9933 19.3995 17.7589 19.6339C17.5245 19.8683 17.2065 20 16.875 20H3.125C2.79348 20 2.47554 19.8683 2.24112 19.6339C2.0067 19.3995 1.875 19.0815 1.875 18.75V1.25C1.875 0.918479 2.0067 0.600537 2.24112 0.366117C2.47554 0.131696 2.79348 0 3.125 0Z",
    fill: "#6392FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0V3.75C13.125 4.08152 13.2567 4.39946 13.4911 4.63388C13.7255 4.8683 14.0435 5 14.375 5H18.125L13.125 0Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 12.2902H8.625V15.0059C8.62499 15.0952 8.6426 15.1836 8.67681 15.266C8.71102 15.3485 8.76117 15.4234 8.82438 15.4864C8.95207 15.6137 9.12502 15.6852 9.30531 15.6852H10.6947C10.875 15.6852 11.048 15.6136 11.1756 15.4862C11.3031 15.3591 11.375 15.1862 11.375 15.0061V12.2902ZM10.6947 13.8461V15.2098H9.30531V13.8461H10.6947ZM11.3522 9.57422V10.9378H9.98594V9.57406H11.3522V9.57422ZM10.0028 0H8.625V1.375H9.99719V2.64828H8.625V4.02328H9.99719V5.39828H8.625V6.75625H9.99719V8.11422H8.625V9.47234H10.0028V8.11437H11.375V6.75625H10.0028V5.39812H11.375V4.02312H10.0028V2.75H11.375V1.375H10.0028V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.6469269d49c52592809c21210377f1cd.svg";
export { ForwardRef as ReactComponent };